import http from "../http-common";
export default class RACMenu {
  getRacMenu() {
    let url = `/rac-menu`;

    return http.get(url);
  }
}

